import ShippingIcon from "@assets/images/shipping-icon.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface ModalAddressProps {
  onClose: () => void;
  visible: boolean;
  address: Array<{ name: string; code: string }>;
  handleApplyAddress: (shipping: string, shippingAddr: string) => void;
  defaultAddress: string;
}

export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "0",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "24px",
      marginTop: "0px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto",
      padding: "0 !important",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    labelRadio: {
      marginBottom: "2rem"
    },
    rowlength: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    formControlLabel: {
      marginBottom: "2.5rem"
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    },
    buttonWrap: {
      padding: "0px",
      marginTop: "24px"
    }
  }),
  { name: "ModalAddress" }
);

const ModalAddress: React.FC<ModalAddressProps> = props => {
  const {
    visible,
    onClose,
    address,
    handleApplyAddress,
    defaultAddress
  } = props;
  const [shipping, setShipping] = useState<string>(defaultAddress || "");
  const [shippingAddr, setShippingAddr] = useState<string>("");
  const classes = useStyles();
  const intl = useIntl();

  const dataRenderModal = {
    iconHead: ShippingIcon,
    nameHead: intl.formatMessage({
      defaultMessage: "เลือกสถานที่จัดส่งสินค้า"
    })
  };

  const handleSubmit = () => {
    handleApplyAddress(shipping, shippingAddr);
    onClose();
  };

  return (
    <Dialog
      open={visible}
      onClose={onClose}
      className={classes.root}
      data-testid="ship-to-modal"
    >
      <DialogTitle className={classes.dialogTitle}>
        <h2 className={classes.dialogTitleWrap}>
          <img src={dataRenderModal?.iconHead} alt="shipping-icon" />
          <MyTypography variant={"h6"} className={classes.nameHead}>
            {dataRenderModal?.nameHead}
          </MyTypography>
        </h2>
      </DialogTitle>
      <DialogContent dividers={false} className={classes.dialogContent}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={shipping}
                onChange={e => {
                  setShipping(e?.target?.value);
                  setShippingAddr(
                    address.find(a => a.code === e?.target?.value).name
                  );
                }}
              >
                {address.map(({ name, code }, index) => (
                  <FormControlLabel
                    className={classes.formControlLabel}
                    key={name + " #" + index}
                    value={code}
                    control={<Radio />}
                    label={name}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.buttonWrap}>
        <Button
          id="pendingOrderAddressCancelButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onClose}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          id="pendingOrderAddressSubmitButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          disabled={!shipping}
          onClick={handleSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ModalAddress.displayName = "ModalAddress";
export default ModalAddress;
